import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { YoutubeShortsEarningsPage } from '../../../pages/tools/creator-tools/YoutubeShortsEarningsPage';

export const Route = createFileRoute('/_site/tools/youtube-shorts-earnings')({
  head: () => toolHead('youtube-shorts-earnings'),
  component: YoutubeShortsEarningsPage,
});
